import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";

export const useContent = (path) =>
  useQuery({
    queryKey: [path],
    queryFn: async () => (await api.get(path)).data,
  });

export const useSettings = () => useContent("/content/settings");
